'use strict'

var objectHasOwn = Object.prototype.hasOwnProperty

module.exports = function(object, propertyName){
    return objectHasOwn.call(object, propertyName)
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/to-style/src/hasOwn.js
// module id = 390
// module chunks = 0